export default "__VITE_ASSET__0fd5866f__"